import * as React from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { ListItemIcon, ListSubheader, Grid } from '@mui/material'
import HeatIcon from '@mui/icons-material/LocalFireDepartment'
import schema from '../../schemas/heatdemand.json'
import { JSONSchema7 } from 'json-schema'
import { HeatDemand } from '../../interfaces/heatdemand'
import EditHeatDemand from './EditHeatDemand'
import DeleteHeatDemand from './DeleteHeatDemand'
import CreateHeatDemand from './CreateHeatDemand'

export interface Props {
	disabled: boolean
	data: HeatDemand[]
	setData: React.Dispatch<React.SetStateAction<any[]>>
}

export default function HeatDemandList({ disabled, data, setData }: Props) {
	return (
		<List
			dense
			subheader={
				<ListSubheader>
					<Grid container alignItems={'center'}>
						{'Heat Demand'}
						<CreateHeatDemand
							disabled={disabled || (data && data.length > 0)}
							data={data}
							schema={schema as JSONSchema7}
							setData={setData}
						/>
					</Grid>
				</ListSubheader>
			}
		>
			{data.map((obj: HeatDemand, index: number) => {
				return (
					<ListItem
						key={index}
						secondaryAction={
							<>
								<EditHeatDemand disabled={disabled} schema={schema as JSONSchema7} value={obj} setData={setData} />
								<DeleteHeatDemand disabled={disabled} value={obj} setData={setData} />
							</>
						}
						disablePadding
					>
						<ListItemButton disabled={disabled}>
							<ListItemIcon>
								<HeatIcon />
							</ListItemIcon>
							<ListItemText
								primary={obj.name}
								secondary={``}
								sx={{ '.MuiListItemText-secondary': { display: { xs: 'none', sm: 'block' } } }}
							/>
						</ListItemButton>
					</ListItem>
				)
			})}
		</List>
	)
}
